module.exports = __webpack_public_path__ + "static/media/Sumeet's Resume.5c7b4da8.pdf";